import { Box } from "@mui/material";
import { useContactSubmissionProjectParams } from "app/frontend/components/contact/useContactSubmissionProjectParams";
import { useIsEligibilityReadOnly } from "app/frontend/components/contact/useIsEligibilityReadOnly";
import AboutYourProjectAccordion from "app/frontend/components/eligibility/accordions/AboutYourProjectAccordion";
import ProjectSizeAccordion from "app/frontend/components/eligibility/accordions/project_size/ProjectSizeAccordion";
import ProjectConfirmationAccordion from "app/frontend/components/eligibility/accordions/ProjectConfirmationAccordion";
import ProjectLocationAccordion from "app/frontend/components/eligibility/accordions/ProjectLocationAccordion";
import ProjectTypeEligibilityAccordion from "app/frontend/components/eligibility/accordions/ProjectTypeEligibilityAccordion";
import ProjectVouchersAccordion from "app/frontend/components/eligibility/accordions/ProjectVouchersAccordion";
import { IEligibilityProps } from "app/frontend/components/eligibility/accordions/types";
import { EEligibilityStep } from "app/frontend/components/eligibility/constants";
import { EIncentiveName, EProjectTypes } from "app/frontend/constants/enums";
import { useParamsProjectType } from "app/frontend/hooks/project/useParamsProjectType";
import { useParams } from "app/frontend/hooks/useParams";
import { useProjectParams } from "app/frontend/hooks/usePropsParams";

const EligibilityAccordions: React.FC = () => {
    const contactParams = useContactSubmissionProjectParams();
    const readOnly = useIsEligibilityReadOnly();
    const projectParams = useProjectParams() || contactParams?.project;
    const projectType = useParamsProjectType() || contactParams?.project_type;

    const { head, edit }: { head: string; edit: string } = useParams();

    const props: IEligibilityProps = {
        head: Number(head),
        edit: Number(edit),
        step: EEligibilityStep.PROJECT_TYPE,
    };

    const isMHD = projectType === EProjectTypes.MHD;
    const isLD = projectType === EProjectTypes.L2;
    const isPublic = projectParams?.incentive_names?.includes(EIncentiveName.PUBLICLY_ACCESSIBLE);

    const shouldRender = (step: EEligibilityStep) => {
        if (readOnly) return true;

        return {
            [EEligibilityStep.PROJECT_TYPE]: props.head >= EEligibilityStep.PROJECT_TYPE,
            [EEligibilityStep.ABOUT]: props.head >= EEligibilityStep.ABOUT && isMHD,
            [EEligibilityStep.VOUCHERS]: props.head >= EEligibilityStep.VOUCHERS && isMHD && !isPublic,
            [EEligibilityStep.LOCATION]: props.head >= EEligibilityStep.LOCATION && isMHD,
            [EEligibilityStep.PROJECT_SIZE]: props.head >= EEligibilityStep.PROJECT_SIZE && (isMHD || isLD),
            [EEligibilityStep.CONFIRMATION]: props.head >= EEligibilityStep.CONFIRMATION,
        }[step];
    };

    return (
        <Box sx={{ py: { xs: 2, lg: "30px" } }}>
            <ProjectTypeEligibilityAccordion {...props} />
            {shouldRender(EEligibilityStep.ABOUT) && <AboutYourProjectAccordion {...props} />}
            {shouldRender(EEligibilityStep.VOUCHERS) && <ProjectVouchersAccordion {...props} />}
            {shouldRender(EEligibilityStep.LOCATION) && <ProjectLocationAccordion {...props} />}
            {shouldRender(EEligibilityStep.PROJECT_SIZE) && <ProjectSizeAccordion {...props} />}
            {!readOnly && shouldRender(EEligibilityStep.CONFIRMATION) && <ProjectConfirmationAccordion {...props} />}
        </Box>
    );
};

export default EligibilityAccordions;
